import swal from "sweetalert";
import axiosInstance from "../api";
import { setCategoriesList, setSingleSize, setSizeListData, setCategoriesAddonList, setCategoriesGiftcardList } from "../../reusableSlice";


export const getAllSize = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`admin/sizes`, { params: data });
      console.log(response,"sdfsf")
      if (response?.data) {
        dispatch(setSizeListData(response?.data?.response))
      } else {
        dispatch(setSizeListData([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setSizeListData([]))
    }
  };

  export const addSize = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("admin/sizes", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/size")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
     // console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const getSingleSize = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`admin/sizes/${id}`);
      console.log(response,"responsesdfssfs")
      if (response?.data) {
        dispatch(setSingleSize(response?.data?.response))
      } else {
        dispatch(setSingleSize([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setSingleSize([]))
    }
  };

  export const updateOneSIze = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.put("admin/sizes", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/size")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
     // console.error(err);
    } finally {
      setLoading(false);
    }
  };



 

  export const deleteOneSize = (id) => async (dispatch) => {
    // setLoading(true);
    try {
      const response = await axiosInstance.delete(`admin/sizes/${id}`);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        window.location.reload()
        // navigate("/membership")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
     // console.error(err);
    } finally {
      // setLoading(false);
    }
  };

  export const getAllCategorieslist = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`admin/categories`, { params: data });
      console.log(response,"sdfsf")
      if (response?.data) {
        dispatch(setCategoriesList(response?.data?.response))
      } else {
        dispatch(setCategoriesList([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setCategoriesList([]))
    }
  };

  export const getAllCategoriesAddonlist = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`admin/categories`, { params: data });
      console.log(response,"sdfsf")
      if (response?.data) {
        dispatch(setCategoriesAddonList(response?.data?.response))
      } else {
        dispatch(setCategoriesAddonList([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setCategoriesAddonList([]))
    }
  };

  export const getAllCategoriesGiftcardlist = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`admin/categories`, { params: data });
      console.log(response,"sdfsf")
      if (response?.data) {
        dispatch(setCategoriesGiftcardList(response?.data?.response))
      } else {
        dispatch(setCategoriesGiftcardList([]))
      }
    } catch (err) {
     // console.error(err);
      dispatch(setCategoriesGiftcardList([]))
    }
  };
